// Basic
import PropTypes from 'prop-types';
// Store & actions
import useSessionStore from '@/app/store/session';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
import { Button } from '@/common-utils/components/ui/button';
import TooltipHelper from '@/common-utils/components/renders/tooltip/TooltipHelper';
// Common
import ICONS from '@/common-utils/enums/icons';
import organizationFields from '../../fields/organizationFields';
import { buildUrl } from '@/common-utils/functions/restUtils';
// Lang
import { nsOrganization } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.legalInfos
 * @returns {JSX} RenderAddress
 */
function RenderAddress({ legalInfos }) {

    // Store
    const { isSmallDevice } = useSessionStore(s => s.session);

    if (!legalInfos) {
        return null;
    }

    return (
        <div className={`legal-address-block${isSmallDevice ? ' small-device' : ''} details-grid-row`}>
            <Entity className='text-labelGray-foreground' entity='keys.legal_address' namespace={nsOrganization} />
            <TooltipHelper
                asChild
                content={<Entity entity='keys.legal_address' namespace={nsOrganization} />}
                contentClass={''}
                trigger={
                    <Button
                        variant='outline'
                        icon={ICONS.MAP}
                        onClick={() => {
                            window.open(buildUrl(
                                'https://www.openstreetmap.org/search',
                                {
                                    // Remove empty lines
                                    query: [
                                        legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L4.key],
                                        legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L6.key]?.replace('CEDEX', '')
                                        // Remove country
                                        // legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L7.key]
                                    ]
                                        .filter(line => line)
                                        .join(', ')
                                }
                            ), '_blank');
                        }
                        }
                    />
                }
            />

            <div className='legal-address font-bold'>
                {
                    legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L1.key] ?
                        <div>{legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L1.key]}</div>
                        : false
                }
                {
                    legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L2.key] ?
                        <div>{legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L2.key]}</div>
                        : false
                }
                {
                    legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L3.key] ?
                        <div>{legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L3.key]}</div>
                        : false
                }
                {
                    legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L4.key] ?
                        <div>{legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L4.key]}</div>
                        : false
                }
                {
                    legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L5.key] ?
                        <div>{legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L5.key]}</div>
                        : false
                }
                {
                    legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L6.key] ?
                        <div>{legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L6.key]}</div>
                        : false
                }
                {
                    legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L7.key] ?
                        <div>{legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L7.key]}</div>
                        : false
                }
            </div>
        </div>
    );
}

RenderAddress.propTypes = {
    legalInfos: PropTypes.object
};

export default RenderAddress;